export enum TabState {
  Starred = 'Starred',
  EverythingElse = 'EverythingElse',
  None = 'None'
}
